<div class="pricing_plans_card">
	<ng-container *ngIf="userDetails.subscription?.payment_by != 'in-app'; else inAppPlanActive">
		<ng-container *ngIf="showSelectPlan; else subscriptionInProgress">
			<ng-container *ngIf="!activePlan || activePlan.original_subscription_plan == 'free' || activePlan.is_manual; else upgradeDowngradePlan">

				<ng-container *ngIf="(!activePlan?.has_free_trial && !activePlan?.has_old_subscriptions); else overFreeTrial">
					<a class="pricing_plans_card-footer" href="javascript:;">
						<button type="button" (click)="startFreeTrial()">Start 30 Day Free Trial</button>
					</a>	
				</ng-container>

				<ng-template #overFreeTrial>

					<div *ngIf="couponDetail; else promocodeForm" class="account-setting__plan--promo-apply py-3 pl-3">
						<div id="coupon-detail" class="text-center" *ngIf="!couponDetail.freelance_document_id">
							<span i18n="@@plan.promocode">Promocode</span>
							<strong>
								{{ couponDetail.coupon_code }}
								({{ couponDetail.coupon_value }}%)
							</strong>
							<button class="cancel-payment-update" (click)="cancelPromocode()"></button>
							<br/>
							<span class="new-price" *ngIf="couponDetail.coupon_type == 'percentage' && couponDetail.discount_message">{{ couponDetail.discount_message }} </span>
						</div>
						<div id="coupon-freelance" class="text-center" *ngIf="couponDetail.freelance_document_id">
							<div>
								<a href="https://freelance.sa/" class="mr-2 align-middle" target="_blank">
									<strong>FREELANCE.SA</strong>
								</a>
								<button class="cancel-payment-update" (click)="cancelPromocode()"></button>
							</div>
							<span class="new-price text-capitalize">{{ couponDetail.discount_message }}</span>
						</div>
					</div>
		
					<ng-template #promocodeForm>
						<form [formGroup]="promoCodeForm" (ngSubmit)="submitPromocode()" class="promocode-form w-100">
							<!-- <fieldset class="freelance_id_checkbox">
								<input type="checkbox" formControlName="is_freelance" class="styled-checkbox" id="freelance_id-{{planAmount}}">
								<label for="freelance_id-{{planAmount}}" i18n="@@plan.use_your_freelacer_id">Use your freelancer ID</label>
							</fieldset> -->
							<div class="plans-box__errorMessage" *ngIf="submitted && promoCodeForm.get('coupon_code').errors">
								<p *ngIf="promoCodeForm.get('coupon_code').errors.required" i18n="@@plan.please_enter_code">Please enter code</p>
								<p *ngIf="promoCodeForm.get('coupon_code').errors.serverError">{{ promoCodeForm.get('coupon_code').errors?.serverError }}</p>
							</div>
							<div class="plans-box__promocode">
								<!-- <fieldset class="no-label" [ngClass]="{'has-error': submitted && promoCodeForm.get('coupon_code').errors }"> -->
									<input type="text" formControlName="coupon_code" i18n-placeholder="@@plan.promocode" placeholder="Promocode" />
		
									<!-- <span class="field-error" *ngIf="promoCodeForm.get('coupon_code').errors">
										<ng-container *ngIf="promoCodeForm.get('coupon_code').errors.required" i18n="@@plan.please_enter_code">Please enter code</ng-container>
										<ng-container *ngIf="promoCodeForm.get('coupon_code').errors.serverError">{{ promoCodeForm.get('coupon_code').errors?.serverError }}</ng-container>
									</span> -->
		
								<!-- </fieldset> -->
								<input i18n-value="@@plan.apply" type="submit" value="Apply" />
							</div>
						</form>
					</ng-template>

					<apple-pay [buttonType]="'new-user'" [planType]="planType" [planFrequency]="planFrequency" [couponDetail]="couponDetail" [planAmount]="planAmount" [userDetails]="userDetails"></apple-pay>	
					
					<button type="button" class="tu-btn plans-box__currentButton" (click)="selectPlan()">
						<span i18n="@@plan.select_plan">Select Plan</span>
					</button>
				</ng-template>
			</ng-container>

			<ng-template #upgradeDowngradePlan>
				
				<a class="pricing_plans_card-footer" href="javascript:;" *ngIf="activePlan && (activePlan.subscription_plan == planType && activePlan.plan_frequency == planFrequency); else changePlanBtn">
					<button type="button" class="tu-btn blue">
						<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M22.5 11.08V12C22.4988 14.1564 21.8005 16.2547 20.5093 17.9818C19.2182 19.709 17.4033 20.9725 15.3354 21.5839C13.2674 22.1953 11.0573 22.1219 9.03447 21.3746C7.01168 20.6273 5.28465 19.2461 4.11096 17.4371C2.93727 15.628 2.37979 13.4881 2.52168 11.3363C2.66356 9.18455 3.49721 7.13631 4.89828 5.49706C6.29935 3.85781 8.19279 2.71537 10.2962 2.24013C12.3996 1.7649 14.6003 1.98232 16.57 2.85999" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M22.5 4L12.5 14.01L9.5 11.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<span i18n="@@plan.current_active_plan">Current Active Plan</span>
					</button>
				</a>

				<ng-template #changePlanBtn>
					<apple-pay [buttonType]="'upgrade-user'" *ngIf="(planType != planTypes.basic || planType != planTypes.individual || planType != planTypes.pro || planType != planTypes.professional);" [planType]="planType" [planFrequency]="planFrequency" [couponDetail]="couponDetail" [planAmount]="planAmount" [userDetails]="userDetails"></apple-pay>

					<button *ngIf="subscriptionBtn == 'downgrade'" (click)="downgradePlan()" class="tu-btn pink select-plan mt-3" i18n="@@plan.downgrade_plan">Downgrade Plan</button>

					<button *ngIf="subscriptionBtn == 'upgrade'"  (click)="upgradePlan()" class="tu-btn pink select-plan mt-3" i18n="@@plan.upgrade_plan">Upgrade Plan</button>

					<!-- <ng-container *ngIf="(activePlan.plan_frequency != planFrequency && activePlan.plan_frequency == 'yearly'); else upgradeCurrentPlan">
						<button (click)="downgradePlan()" class="tu-btn pink select-plan mt-3" i18n="@@plan.downgrade_plan">Downgrade Plan</button>
					</ng-container>

					<ng-template #upgradeCurrentPlan>
						<ng-container *ngIf="(activePlan.payment_by =='apple-pay'); else payFortUpgradePlanBtn"></ng-container>
						<ng-template #payFortUpgradePlanBtn>
							<div *ngIf="(planType == planTypes.basic || planType == planTypes.individual) && (activePlan.plan_frequency == planFrequency); then downgradePlanBtn else upgradePlanBtn"></div>

							<ng-template #downgradePlanBtn>
								<button (click)="downgradePlan()" class="tu-btn pink select-plan mt-3" i18n="@@plan.downgrade_plan">Downgrade Plan</button>
							</ng-template>

							<ng-template #upgradePlanBtn>
								<div *ngIf="(planType == planTypes.pro || planType == planTypes.professional) && (activePlan.plan_frequency == planFrequency); then downgradePlanBtnn else upgradePlanBtnn"></div>
								<ng-template #downgradePlanBtnn>
									<button *ngIf="(activePlan.subscription_plan == planTypes.business); else upgradeBusinessBtn" (click)="downgradePlan()" class="tu-btn pink select-plan mt-3" i18n="@@plan.downgrade_plan">Downgrade Plan</button>
									<ng-template #upgradeBusinessBtn>
										<button (click)="upgradePlan()" class="tu-btn pink select-plan mt-3" i18n="@@plan.upgrade_plan">Upgrade Plan</button>
									</ng-template>
								</ng-template>
								<ng-template #upgradePlanBtnn>
									<button (click)="upgradePlan()" class="tu-btn pink select-plan mt-3" i18n="@@plan.upgrade_plan">Upgrade Plan</button>
								</ng-template>
							</ng-template>
						</ng-template>
					</ng-template> -->
				</ng-template>
			</ng-template>
		</ng-container>

		<ng-template #subscriptionInProgress>
			<ng-container *ngIf="isCurrentPlan(); else noselect">
				<a href="javascript:void();" class="tu-btn icon-left blue plans-box__currentButton" >
					<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M22.5 11.08V12C22.4988 14.1564 21.8005 16.2547 20.5093 17.9818C19.2182 19.709 17.4033 20.9725 15.3354 21.5839C13.2674 22.1953 11.0573 22.1219 9.03447 21.3746C7.01168 20.6273 5.28465 19.2461 4.11096 17.4371C2.93727 15.628 2.37979 13.4881 2.52168 11.3363C2.66356 9.18455 3.49721 7.13631 4.89828 5.49706C6.29935 3.85781 8.19279 2.71537 10.2962 2.24013C12.3996 1.7649 14.6003 1.98232 16.57 2.85999" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M22.5 4L12.5 14.01L9.5 11.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<span i18n="@@plan.current_active_plan">Current Active Plan</span>
				</a>
			</ng-container>

			<ng-template #noselect>
				<p *ngIf="showSubscriptionInProgress && activePlan && activePlan.pending_request" class="text-danger mx-4" >
					<ng-container *ngIf="(planType == 'pro' || planType == 'professional') || !activePlan.pending_request.start_date" i18n="@@plan.last_request_inprogress">Last subscription request is in progress.</ng-container>
					<ng-container *ngIf="(planType == 'basic' || planType == 'individual') && activePlan.pending_request.start_date" i18n="@@plan.downgrade_inprogress">This plan will be active on <br/> {{ activePlan.pending_request.start_date | date: 'dd-MMM-yyyy'}}</ng-container>
				</p>
				<div class="{{ isCurrentPlanFrequency() ? 'p-2' : 'p-3' }}"></div>
			</ng-template>
		</ng-template>
	</ng-container>

	<ng-template #inAppPlanActive>
		<p class="text-danger text-center mx-4">
			<ng-container i18n="@@plan.proceed_to_app_store_to_upgrade">Please proceed to the mobile application to upgrade or cancel your active subscription.</ng-container>
		</p>
	</ng-template>	
</div>